import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class AppService {
  setIsLimitedApplication(isLimitedApplication: boolean): void {
    sessionStorage.setItem('isLimitedApplication', isLimitedApplication.toString())
  }

  getIsLimitedApplication(): boolean {
    return sessionStorage.getItem('isLimitedApplication') === 'true'
  }
}
